import { API_BASE_PATH } from '@/config';
import { axios } from '@/lib/axios';
import { Data } from '@/types';

import { LoginResponse } from '../types';

import { getCsrfToken } from './getCsrfToken';

export type LoginCredentialsDTO = {
  email: string;
  password: string;
};

export const loginWithEmailAndPassword = async (
  data: LoginCredentialsDTO
): Promise<Data<LoginResponse>> => {
  await getCsrfToken();
  return axios.post(`${API_BASE_PATH}/login`, data);
};
